import { keys } from 'lodash';

const subGroupMapping = {
  'Run Instance List': { title: 'List', group: 'Run Instance' },
  'Run Instance Summary': { title: 'Summary', group: 'Run Instance' },
  'NS Alert List': { title: 'NS', group: 'Alert List' },
  'TS Alert List': { title: 'TS', group: 'Alert List' },
  'NS Alert Detail': { title: 'NS', group: 'Alert Detail' },
  'TS Alert Detail': { title: 'TS', group: 'Alert Detail' }
};

const groupMapping = {
  'Matching Config List': 'UI Settings',
  'Run Instance': 'UI Settings',
  'Alert List': 'UI Settings',
  'Alert Detail': 'UI Settings',
  'Watchlist List': 'UI Settings',
  'Whitelist List': 'UI Settings',
  'Ticket List': 'UI Settings',
  'TM IAD': 'UI Settings',
  Fraud: 'UI Settings',
  'Customer Listing': 'UI Settings',
  'Customer Details': 'UI Settings',
  'Alert Listing': 'UI Settings',
  'Alert Details': 'UI Settings'
};

export const getGroupedTabs = (tabs) => {
  const subGroup = {};
  tabs?.forEach((tab, index) => {
    if (subGroupMapping[tab]) {
      const groupKey = subGroupMapping[tab].group;
      if (subGroup[groupKey]) {
        subGroup[groupKey].list.push({
          index,
          tab,
          ...subGroupMapping[tab]
        });
        subGroup[groupKey].indexes.push(index);
      } else {
        subGroup[groupKey] = {
          list: [{ index, tab, ...subGroupMapping[tab] }],
          indexes: [index]
        };
      }
    } else {
      subGroup[tab] = { index, tab };
    }
  });

  const group = {};
  keys(subGroup).forEach((tab, index) => {
    if (groupMapping[tab]) {
      const groupKey = groupMapping[tab];
      if (group[groupKey]) {
        group[groupKey].list.push(subGroup[tab]);
        group[groupKey].indexes = group[groupKey].indexes.concat(
          ...(subGroup[tab].indexes
            ? subGroup[tab].indexes
            : [subGroup[tab].index])
        );
      } else {
        group[groupKey] = {
          list: [subGroup[tab]],
          indexes: [
            ...(subGroup[tab].indexes
              ? subGroup[tab].indexes
              : [subGroup[tab].index])
          ]
        };
      }
    } else {
      group[tab] = subGroup[tab];
    }
  });

  return group;
};
